<template>
  <b-card
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title> {{ $t('Asset Quality Ratio') }}</b-card-title>
      <feather-icon
        icon="RotateCwIcon"
        class="cursor-pointer"
        @click="fetchAssetQualityRatio"
      />
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          v-for="(item, index) in assetQualityRation"
          :key="index.toString()"
          xl="4"
          sm="12"
          :class="index > 2 ? 'mt-2' : '' && item.customClass"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-1"
            >
              <b-avatar
                size="30"
                :variant="item.color"
              >
                <feather-icon
                  size="20"
                  :icon="item.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <b-card-text class="font-small-3 mb-0">
                {{ item.subtitle }}
              </b-card-text>
              <h5 class="font-weight-bolder mb-0 text-wrap">
                {{ item.title }}
              </h5>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
    <Spinner :show="isLoadingAssetQualityRatio" />
  </b-card>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'
import {
  BAvatar,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol, BMedia, BMediaAside,
  BMediaBody,
  BRow,
} from 'bootstrap-vue'
import { useActions } from 'vuex-composition-helpers'
import Spinner from '@/views/components/spinner/Spinner.vue'
import useToastAlert from '../../../composable/useToast'
import addSpaceToString from '../../../helpers/addSpaceToString'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    Spinner,
  },
  setup() {
    const { getAssetQualityRation } = useActions({ getAssetQualityRation: 'dashboard/getAssetQualityRation' })
    const { toastAlert } = useToastAlert()
    const assetQualityRation = ref([])
    const isLoadingAssetQualityRatio = ref(false)
    const getColor = item => {
      if (item === 'percentageOfLoansToDeposits') {
        return 'light-primary'
      }
      if (item === 'microLoanAsAPercentageOfTotalLoan') {
        return 'light-info'
      }
      if (item === 'savingsAsAPercentageOfTotalDeposits') {
        return 'light-danger'
      }
      // if (item === 'singleObligorLimitForIndividualCustomerLending') {
      //   return 'light-secondary'
      // }
      // if (item === 'singleObligorLimitForGroupCorporateCustomerLending') {
      //   return 'light-warning'
      // }
      return 'light-success'
    }

    const getIcon = item => {
      if (item === 'percentageOfLoansToDeposits') {
        return 'ActivityIcon' // Ratio/balance indicator
      }
      if (item === 'microLoanAsAPercentageOfTotalLoan') {
        return 'PieChartIcon' // Portion of total
      }
      if (item === 'savingsAsAPercentageOfTotalDeposits') {
        return 'DatabaseIcon' // Savings/deposits storage
      }
      // if (item === 'singleObligorLimitForIndividualCustomerLending') {
      //   return 'ClipboardIcon'
      // }
      // if (item === 'singleObligorLimitForGroupCorporateCustomerLending') {
      //   return 'ClipboardIcon'
      // }
      return 'TrendingDownIcon'
    }

    const fetchAssetQualityRatio = async () => {
      try {
        isLoadingAssetQualityRatio.value = true
        const response = await getAssetQualityRation()

        const { status, data } = response
        if (status === 200 && data) {
          const myData = {
            percentageOfLoansToDeposits: `${data.summary.assetQualityRatio}%`,
            microLoanAsAPercentageOfTotalLoan: `${data.summary.microLoanAssetRatio}%`,
            savingsAsAPercentageOfTotalDeposits: `${data.summary.savingsRatio}%`,
            // singleObligorLimitForIndividualCustomerLending: '15%',
            // singleObligorLimitForGroupCorporateCustomerLending: '27%',
          }
          assetQualityRation.value = Object.entries({ ...myData }).map(([key, value]) => ({
            icon: getIcon(key),
            color: getColor(key),
            title: value,
            // subtitle: addSpaceToString(key),
            // eslint-disable-next-line no-nested-ternary
            subtitle: addSpaceToString(key === 'percentageOfLoansToDeposits' ? 'percentageOfLoansToDeposits (80%)' : key === 'microLoanAsAPercentageOfTotalLoan' ? 'microLoanAsAPercentageOfTotalLoan (80%)' : key === 'savingsAsAPercentageOfTotalDeposits' ? 'savingsAsAPercentageOfTotalDeposits (60%)' : ''),
            // subtitle: addSpaceToString(key === 'percentageOfLoansToDeposits' ? 'percentageOfLoansToDeposits (80%)' : key === 'microLoanAsAPercentageOfTotalLoan' ? 'microLoanAsAPercentageOfTotalLoan (80%)' : key === 'savingsAsAPercentageOfTotalDeposits' ? 'savingsAsAPercentageOfTotalDeposits (60%)' : key === 'singleObligorLimitForIndividualCustomerLending' ? 'singleObligorLimitForIndividualCustomerLending (<= 1%)' : 'singleObligorLimitForGroup/CorporateCustomerLending (<= 5%)'),
            customClass: 'mb-2 mb-xl-0',
            ...value,
          }))
          isLoadingAssetQualityRatio.value = false
        }
      } catch (err) {
        toastAlert(err)
      } finally {
        isLoadingAssetQualityRatio.value = false
      }
    }

    onMounted(async () => {
      await fetchAssetQualityRatio()
    })

    return {
      assetQualityRation,
      fetchAssetQualityRatio,
      isLoadingAssetQualityRatio,
    }
  },
}
</script>
